export enum PopupType {
    EMPTY = "",
    POPUP_CONTACT = "popupContact",
    TERMS_OF_USE = "termsOfUse",
    ACCESSIBILITY_STATMENT = 'accessibilityStatement'
}
